import axios from 'axios'

const getServerUrl = () => {
    return localStorage.getItem('treelist-single-user-server-url')
}

export const getState = async () => {
    const url = getServerUrl()
    return axios.get(url).then((response) => response.data)
}

export const postState = async (tree) => {
    const url = getServerUrl()
    return axios.post(url, tree).then((response) => response.data)
}

export const postPartialState = async (treeDiff) => {
    const baseURL = getServerUrl()
    let urlObj
    try {
        urlObj = new URL(baseURL)
    } catch (e) {
        throw new Error('Server URL is not valid')
    }
    urlObj.pathname += '/tree-diff'
    const url = urlObj.toString()

    return axios.post(url, treeDiff).then((response) => response.data)
}

export const getStateHash = async () => {
    const baseURL = getServerUrl()
    let urlObj
    try {
        urlObj = new URL(baseURL)
    } catch (e) {
        throw new Error('Server URL is not valid')
    }
    urlObj.pathname += '/hash'
    const url = urlObj.toString()
    return axios.get(url).then((response) => response.data)
}
